import {Form, Input, notification, Typography} from "@ui";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {PrimaryButton} from "@/components/Button";
import useRecoverPassword from "@/hooks/useRecoverPassword";
import {useUserSupport} from "@/store/useUserSupport.store";
import {useLogo} from "../../util/logoUtils";
import styles from "./MobilePasswordRecovery.module.css";

const MobilePasswordRecovery = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const logo = useLogo();
  const [form] = Form.useForm();

  const {requestPassword, isSuccess, isPending} = useRecoverPassword();
  const handleSupportModal = useUserSupport(state => state.handleSupportModal);

  useEffect(() => {
    if (isSuccess) {
      notification.success({
        message: t("loginPasswordRecover"),
        description: t("loginPasswordRecoverMsg"),
      });
    }
  }, [isSuccess, t]);

  const onFinish = values => {
    requestPassword(values.username.trim());
  };

  const onFinishFailed = _errorInfo => {};

  return (
    <div className={styles.mobilePasswordRecoveryContainer}>
      <div className={styles.mobilePasswordRecoveryContent}>
        <div className={styles.logoContainer}>
          <img
            src={logo}
            alt="logo"
            className={styles.logo}
          />
        </div>

        <div className={styles.formContainer}>
          <Form
            form={form}
            name="mobile-password-recovery"
            className={styles.form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            <div className={styles.formInner}>
              <h3 className={styles.title}>{t("loginPasswordRecoverTitle")}</h3>

              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: t("loginUserName"),
                  },
                ]}
                style={{width: "100%", marginBottom: "20px"}}
              >
                <Input
                  placeholder={t("loginEmailPlaceholder")}
                  className={styles.input}
                />
              </Form.Item>

              <Form.Item style={{textAlign: "center", marginBottom: "20px"}}>
                <PrimaryButton
                  htmlType="submit"
                  loading={isPending}
                  className={styles.submitButton}
                >
                  {t("loginSendBtn")}
                </PrimaryButton>
              </Form.Item>

              <Form.Item style={{textAlign: "center", marginBottom: "10px"}}>
                <Typography.Text
                  onClick={() => navigate("/mobile-login")}
                  className={styles.backToLoginLink}
                >
                  {t("loginSessionTitle")}
                </Typography.Text>
              </Form.Item>

              <Form.Item style={{textAlign: "center", marginBottom: 0}}>
                <Typography.Text className={styles.noAccountText}>
                  {t("loginNoAccount")}
                  <Typography.Link
                    className={styles.registerLink}
                    style={{color: "var(--action-primary)"}}
                    onClick={() => navigate("/mobile-registration")}
                  >
                    {t("loginRegister")}
                  </Typography.Link>
                </Typography.Text>
                <p className={styles.supportText}>
                  {t("loginRecoverEmail")}{" "}
                  <Typography.Link
                    className={styles.supportLink}
                    onClick={() => handleSupportModal(true)}
                  >
                    {t("loginSupport")}
                  </Typography.Link>
                </p>
              </Form.Item>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MobilePasswordRecovery;
